<template>
  <div>
    <Listing />
  </div>
</template>

<script>
import Listing from "./listing.vue";
export default {
  name: "VehiclesContainer",
  data() {
    return {
      mainTitle: "Main Title",
      subTitle: "Sub Title",
    };
  },
  created() {
    this.$parent.pageTitle = this.mainTitle;
  },
  components: {
    Listing,
  },
};
</script>
